import React from 'react';
import { Link } from 'react-router-dom'; // Added for client-side routing on internal links

const GetStarted = () => {
  return (
    <section className="get-started">
      <div className="container">
        <h2>Ready to Get Started?</h2>
        <p>Join thousands of users who trust BankSystem for their financial needs. Experience the future of banking today.</p>
        <div className="get-started-buttons">
          <a href="https://banksystem.co/banksystem/" className="btn btn-gold">Create Wallet</a>
        </div>
      </div>
    </section>
  );
};

export default GetStarted;
